import { useSelector } from 'react-redux';

import { userSelectors } from '../../../store/modules/user';

const useDestinationLimit = () => {
  const maxStreamDestinations = useSelector(userSelectors.selectMaxDestinations);
  const canUseSamTypeDestination = useSelector(userSelectors.selectCanUseSameTypeDestinations);

  return { maxStreamDestinations, canUseSamTypeDestination };
};

export default useDestinationLimit;
